import Vue from 'vue'
import Vuex from 'vuex'

import address from './modules/address.js'
import userInfo from './modules/userInfo.js'
import goods from './modules/goods.js'
import VueXAlong from 'vuex-along'
Vue.use(Vuex)


export default new Vuex.Store({
  modules: {
	userInfo,
    address,
	goods
  },
  // plugins: [createVuexAlong()]
  plugins: [VueXAlong({
		name: 'robot',     //存放在localStroage或者sessionStroage 中的名字
		local: false, 
		session: { list: [], isFilter: true },
		})
	]
})

